import React from 'react';
import {PropTypes} from "prop-types";
import Modal from "@mui/material/Modal";
import makeStyles from '@mui/styles/makeStyles';

function getDefaultModalStyle() {
    const top = 50;
    const left = 50;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
        transition: 'all 0.3s ease'
    };
}

const StandardModal = (props) => {
    const ModalContext = React.createContext();

    const useStyles = makeStyles((theme) => ({
        paper: {
            position: 'absolute',
            minWidth: 275,
            maxHeight: '90vh',
            maxWidth: "calc(100vw - 32px)",
            backgroundColor: theme.palette.background.paper,
            border: 'none',
            boxShadow: theme.shadows[5],
            outline: 0,
        },
        modalHeader: {
            padding: theme.spacing(2, 4, 0),
        },
        modalBody: {
            overflowY: (props.isScrollable) ? 'scroll' : 'visible',
            overflowX: 'visible',
            padding: theme.spacing(4, 4, 3),
            maxHeight: 'calc(90vh - 140px)',
        },
        modalFooter: {
            padding: theme.spacing(2, 4, 3),
        }
    }));

    let classes = useStyles();

    const [modalStyle] = React.useState({
        ...getDefaultModalStyle(),
        ...props.style,
    })

    const hasPrimaryButtons = () => {
        return (props.buttons && props.buttons.length > 0);
    }

    const hasSecondaryButtons = () => {
        return (props.secondaryButtons && props.secondaryButtons.length > 0);
    }

    const modalCloseButton = () => {
        if (props.hideCloseButton) {
            return null;
        }
        return (
            <button type="button"
                className="clear button secondary large no-outline"
                style={{position: 'absolute', top: '3px', right: '0', zIndex: 1}}
                onClick={props.onClose}
            >
                <i className="fa fa-close"/>
            </button>
        );
    }

    const getScrollGradientClass = () => {
        if (!props.showGradient) {
            return '';
        }
        if (!props.isScrollable) {
            return '';
        }
        return 'scroll-container';
    }

    return (
        <Modal
            open={props.open}
            onClose={props.onClose}
            className={`standard-modal ${props.className ?? ''}`}
        >
            <div
                className={classes.paper}
                style={modalStyle}
            >
                <div className={classes.modalHeader}>
                    {(props.title) && (
                        <h2 className="text-center">
                            {props.title}
                            {modalCloseButton()}
                        </h2>
                    )}

                    {(!props.title) && (
                        <div>{modalCloseButton()}</div>
                    )}
                </div>

                <div className={`${classes.modalBody} ${getScrollGradientClass()}`}>
                    {(props.message && props.message.length) && (
                        <div className="margin-bottom-2 text-center" style={{maxWidth: '400px', marginLeft: 'auto', marginRight: 'auto'}}>
                            <div dangerouslySetInnerHTML={{__html: props.message}} />
                        </div>
                    )}

                    {(props.children) && (
                        props.children
                    )}
                </div>

                {(hasPrimaryButtons() || hasSecondaryButtons()) && (
                    <div className={classes.modalFooter}>
                        <div className="grid-x">
                            {hasSecondaryButtons() && (
                                <div className="cell auto">
                                    <div className="button-group margin-bottom-0">
                                        {Object
                                            .keys(props.secondaryButtons)
                                            .map(key => <React.Fragment key={key}>
                                                {props.secondaryButtons[key]}
                                            </React.Fragment>)
                                        }
                                    </div>
                                </div>
                            )}

                            {hasPrimaryButtons() && (
                                <div className="cell auto text-right">
                                    <div className="button-group align-right text-right margin-bottom-0">
                                        {Object
                                            .keys(props.buttons)
                                            .map(key => <React.Fragment key={key}>
                                                {props.buttons[key]}
                                            </React.Fragment>)
                                        }
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>

        </Modal>
    )
}

StandardModal.propTypes = {
    title: PropTypes.string,
    message: PropTypes.string,

    open: PropTypes.bool,
    onClose: PropTypes.func,
    buttons: PropTypes.array,
    secondaryButtons: PropTypes.array,

    className: PropTypes.string,
    isScrollable: PropTypes.bool,
    showGradient: PropTypes.bool,
    hideCloseButton: PropTypes.bool,
}

export default StandardModal;
